import { useLocalizationText } from "@store/localizationStore";
import { useTitleManager } from "@store/nodeContextStore";

export const usePageTitle = (title?: string) => {
    const t = useLocalizationText();
    const headerText = t('NEN-644069');
    const newTitle = title ? `${title} | ${headerText}` : headerText;
    useTitleManager().title = newTitle;
}
